import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { CalendarIcon, UserIcon } from '../components/Icons/Icons';
import './BlogDetail.css';

function BlogDetail() {
  const article = {
    id: 1,
    title: 'Top 10 Investment Areas in Karachi 2024',
    description: 'Discover the most promising real estate investment opportunities in Pakistan\'s largest city.',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80',
    category: 'Investment',
    date: 'December 28, 2024',
    readTime: '5 min read',
    author: 'Ahmed Khan',
    authorImage: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200',
    content: `
      <p>Karachi, Pakistan's largest metropolis and economic hub, continues to present lucrative opportunities for real estate investors. With a rapidly growing population and expanding infrastructure, the city's property market remains one of the most dynamic in the country.</p>

      <h2>1. DHA Phase 8</h2>
      <p>Defence Housing Authority Phase 8 has emerged as one of the most sought-after residential areas. With its modern infrastructure, excellent amenities, and strategic location, DHA Phase 8 offers both residential and commercial investment opportunities. Properties here have shown consistent appreciation, making it an ideal choice for long-term investors.</p>

      <h2>2. Bahria Town Karachi</h2>
      <p>This mega-project has transformed the real estate landscape of Karachi. Spanning over 45,000 acres, Bahria Town Karachi offers a complete living experience with international-standard facilities. The development's master-planned approach ensures sustained value growth, making it perfect for both end-users and investors.</p>

      <h2>3. Clifton Block 2 & 4</h2>
      <p>Located in the heart of Karachi's most prestigious neighborhood, Clifton continues to be a prime choice for luxury residential investments. The area's proximity to the sea, upscale shopping districts, and recreational facilities makes it a perennial favorite among high-net-worth individuals.</p>

      <h2>4. Gulistan-e-Jauhar</h2>
      <p>This middle-class residential area has shown remarkable growth potential. With its affordable housing options and improving infrastructure, Gulistan-e-Jauhar attracts a large number of first-time homebuyers and investors looking for steady returns.</p>

      <h2>5. North Nazimabad</h2>
      <p>Centrally located and well-connected, North Nazimabad offers excellent value for money. The area's mature infrastructure, established community, and proximity to commercial hubs make it an attractive option for investors seeking rental income.</p>

      <h2>6. Malir Development Authority (MDA)</h2>
      <p>Offering affordable plots and modern planning, MDA schemes present opportunities for budget-conscious investors. The area's development is backed by government initiatives, ensuring basic amenities and infrastructure development.</p>

      <h2>7. Scheme 33</h2>
      <p>This rapidly developing area offers a mix of residential and commercial opportunities. With improving connectivity and infrastructure development, Scheme 33 is becoming increasingly popular among middle-income families and investors.</p>

      <h2>8. Precinct 27, Bahria Town</h2>
      <p>Within Bahria Town Karachi, Precinct 27 stands out for its dedicated sports complex and recreational facilities. The precinct's unique features and modern amenities make it particularly attractive for families and sports enthusiasts.</p>

      <h2>9. Creek Vista, DHA Phase 8</h2>
      <p>This waterfront development offers stunning creek views and modern high-rise living. Creek Vista combines luxury with investment potential, attracting both local and overseas Pakistani investors.</p>

      <h2>10. Super Highway Commercial</h2>
      <p>The commercial developments along Super Highway have gained significant traction. With industrial growth and improved connectivity, commercial plots in this area offer substantial returns for business investors.</p>

      <h2>Investment Tips for 2024</h2>
      <p>When investing in Karachi real estate:</p>
      <ul>
        <li>Always verify property documentation and legal clearances</li>
        <li>Consider location, infrastructure development, and future growth potential</li>
        <li>Diversify your portfolio across different areas and property types</li>
        <li>Work with reputable real estate agents and legal advisors</li>
        <li>Stay updated on government policies and development plans</li>
        <li>Consider both rental yield and capital appreciation potential</li>
      </ul>

      <h2>Conclusion</h2>
      <p>Karachi's real estate market offers diverse investment opportunities catering to different budgets and investment strategies. Whether you're looking for luxury residential properties, affordable housing, or commercial investments, the city has something for everyone. As always, thorough research and professional guidance are key to making successful real estate investments.</p>

      <p>Remember to conduct proper due diligence, understand market trends, and align your investment with your financial goals and risk tolerance. The areas mentioned above represent some of the best opportunities in 2024, but the right choice ultimately depends on your individual investment objectives.</p>
    `
  };

  return (
    <div className="blog-detail-page">
      <Header />

      <div className="blog-detail-container">
        <article className="blog-article">
          <div className="article-hero">
            <img src={article.image} alt={article.title} className="hero-image" />
            <div className="hero-overlay"></div>
            <div className="hero-content">
              <span className="article-category-badge">{article.category}</span>
              <h1 className="article-title">{article.title}</h1>
              <div className="article-meta-hero">
                <div className="meta-item">
                  <UserIcon size={18} color="#ffffff" />
                  <span>{article.author}</span>
                </div>
                <div className="meta-item">
                  <CalendarIcon size={18} color="#ffffff" />
                  <span>{article.date}</span>
                </div>
                <div className="meta-item">
                  <span>{article.readTime}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="article-body">
            <div className="article-author">
              <img src={article.authorImage} alt={article.author} className="author-image" />
              <div className="author-info">
                <h4>{article.author}</h4>
                <p>Real Estate Expert & Market Analyst</p>
              </div>
            </div>

            <div className="article-content" dangerouslySetInnerHTML={{ __html: article.content }} />

            <div className="article-footer">
              <div className="article-tags">
                <span className="tag">Real Estate</span>
                <span className="tag">Investment</span>
                <span className="tag">Karachi</span>
                <span className="tag">2024</span>
              </div>
            </div>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
}

export default BlogDetail;
